export default __webpack_public_path__ + "static/media/faithEke.ecfe4a33.png";